export default "<div *ngIf=\"page\" [innerHTML]=\"page.text | safeUrl:'html'\"></div>\n\n";